import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DepartmentForm from '../../../../components/masters/department/department/DepartmentForm';
import DepartmentTable from '../../../../components/masters/department/department/DepartmentTable';
import { fetchDepartments, addDepartment, updateDepartment, deleteDepartment, setDepartmentEdit, clearDepartmentEdit } from '../../../../redux/actions/masters/department/department/departmentAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchDepartmentGroups } from '../../../../redux/actions/masters/department/departmentGroup/departmentGroupAction';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .department-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .department-form, .department-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const DepartmentPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingDepartment, formSuccess, formError } = useSelector(state => state.department || {});
  const departmentGroups = useSelector(state => state.departmentGroup.list || []);
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchDepartments());
    dispatch(fetchDepartmentGroups());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearDepartmentEdit());
  };

  const handleSubmit = async (form) => {
    if (editingDepartment && editingDepartment.department_id) {
      await dispatch(updateDepartment(editingDepartment.department_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addDepartment(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (department) => {
    dispatch(setDepartmentEdit(department));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteDepartment(id));
  };

  const handleCancel = () => {
    dispatch(clearDepartmentEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      d => d.department_code === code && (!excludeId || d.department_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="department-flex">
        <div style={tableContainer} className="department-table">
          <DepartmentTable
            onNew={handleFormReset}
            departments={list}
            departmentGroups={departmentGroups}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="department-form">
          <DepartmentForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingDepartment={editingDepartment}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            departmentGroups={departmentGroups}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default DepartmentPage; 